(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-cart"]) return;
  try {
    
  // La quantité saisie au clavier met le panier à jour sans bouton
  document.addEventListener('change', function (e) {
    var input = e.target.closest && e.target.closest('#cart-form [data-cart-input]');
    if (input && input.form) input.form.submit();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
(function () {
  function closeAll(except) {
    document.querySelectorAll('.hs.is-open').forEach(function (h) {
      if (h !== except) { h.classList.remove('is-open'); var d = h.querySelector('.hs__dot'); if (d) d.setAttribute('aria-expanded', 'false'); }
    });
  }
  document.addEventListener('click', function (e) {
    if (e.target.closest('.hs__card')) { e.stopPropagation(); return; }
    var dot = e.target.closest('.hs__dot');
    if (dot) {
      e.preventDefault(); e.stopPropagation();
      var h = dot.closest('.hs');
      closeAll(h);
      var open = h.classList.toggle('is-open');
      dot.setAttribute('aria-expanded', open ? 'true' : 'false');
      return;
    }
    closeAll(null);
  }, true);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAll(null); });

  function sync(value) {
    document.querySelectorAll('[data-vcompare]').forEach(function (box) {
      var idx = -1;
      box.querySelectorAll('[data-vc-pick]').forEach(function (b, i) {
        var on = b.getAttribute('data-vc-pick') === value;
        b.classList.toggle('is-active', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
        if (on) idx = i;
      });
      box.querySelectorAll('tbody tr').forEach(function (tr) {
        tr.querySelectorAll('td').forEach(function (td, i) { td.classList.toggle('is-col', i === idx + 1); });
      });
    });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-vc-pick]');
    if (b) {
      var v = b.getAttribute('data-vc-pick');
      var opt = Array.prototype.find.call(document.querySelectorAll('[data-variant-picker] .opt'), function (o) { return o.getAttribute('data-option-value') === v; });
      if (opt) opt.click();
      sync(v);
      return;
    }
    var o = e.target.closest('[data-variant-picker] .opt');
    if (o) setTimeout(function () { sync(o.getAttribute('data-option-value')); }, 0);
  });

  /* Galerie : glisser, points, plein écran */
  var main = document.getElementById('g-main');
  if (main) {
    var thumbs = Array.prototype.slice.call(document.querySelectorAll('#g-thumbs .thumb'));
    var dots = Array.prototype.slice.call(main.querySelectorAll('.g-dots i'));
    var cur = function () { var a = main.querySelector('.gallery__slide.is-active'); return a ? +a.getAttribute('data-slide') : 0; };
    var markDots = function () { var k = cur(); dots.forEach(function (d, i) { d.classList.toggle('is-on', i === k); }); };
    var go = function (k) { if (!thumbs.length) return; k = (k + thumbs.length) % thumbs.length; thumbs[k].click(); markDots(); };
    thumbs.forEach(function (t) { t.addEventListener('click', function () { setTimeout(markDots, 0); }); });
    var sx = 0, sy = 0, moved = false;
    main.addEventListener('touchstart', function (e) { var t = e.touches[0]; sx = t.clientX; sy = t.clientY; moved = false; }, { passive: true });
    main.addEventListener('touchmove', function (e) { var t = e.touches[0]; if (Math.abs(t.clientX - sx) > 10 || Math.abs(t.clientY - sy) > 10) moved = true; }, { passive: true });
    main.addEventListener('touchend', function (e) { var t = e.changedTouches[0], dx = t.clientX - sx, dy = t.clientY - sy; if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.3) { go(cur() + (dx < 0 ? 1 : -1)); } });

    var lb = document.getElementById('lb');
    if (lb) {
      var track = lb.querySelector('[data-lb-track]');
      var slides = Array.prototype.slice.call(lb.querySelectorAll('.lb__slide'));
      var num = lb.querySelector('[data-lb-n]');
      var lastFocus = null;
      var load = function (s) { var im = s && s.querySelector('img[data-src]'); if (im) { im.src = im.getAttribute('data-src'); im.removeAttribute('data-src'); } };
      var idx = function () { return Math.round(track.scrollLeft / Math.max(1, track.clientWidth)); };
      var unzoom = function () { slides.forEach(function (s) { s.classList.remove('is-zoom'); }); lb.classList.remove('is-zoomed'); };
      var show = function (i, smooth) { i = Math.max(0, Math.min(slides.length - 1, i)); unzoom(); load(slides[i]); load(slides[i + 1]); load(slides[i - 1]); track.scrollTo({ left: i * track.clientWidth, behavior: smooth ? 'smooth' : 'auto' }); num.textContent = i + 1; };
      var open = function (forced) {
        var k = typeof forced === 'number' ? forced : cur(), start = 0;
        slides.forEach(function (s, i) { if (+s.getAttribute('data-media') === k) start = i; });
        if (!slides.some(function (s) { return +s.getAttribute('data-media') === k; }) && main.querySelector('.gallery__slide.is-active video, .gallery__slide.is-active iframe, .gallery__slide.is-active model-viewer')) return;
        lastFocus = document.activeElement; lb.hidden = false; document.body.classList.add('no-scroll');
        requestAnimationFrame(function () { show(start, false); lb.querySelector('[data-lb-close]').focus(); });
      };
      var close = function () { lb.hidden = true; unzoom(); document.body.classList.remove('no-scroll'); if (lastFocus) lastFocus.focus(); };
      main.addEventListener('click', function (e) {
        if (e.target.closest('.hs, .hotspots button, video, iframe, model-viewer')) return;
        if (moved) { moved = false; return; }
        open();
      });
      document.addEventListener('click', function (e) { var d = e.target.closest('[data-lb-index]'); if (d) open(+d.getAttribute('data-lb-index')); });
      track.addEventListener('scroll', function () { var i = idx(); num.textContent = i + 1; load(slides[i]); load(slides[i + 1]); }, { passive: true });
      lb.addEventListener('click', function (e) {
        if (e.target.closest('[data-lb-close]')) { close(); return; }
        var st = e.target.closest('[data-lb-step]'); if (st) { show(idx() + +st.getAttribute('data-lb-step'), true); return; }
        var s = e.target.closest('.lb__slide'); if (!s) return;
        if (s.classList.contains('is-zoom')) { unzoom(); return; }
        var r = s.getBoundingClientRect(), fx = (e.clientX - r.left) / r.width, fy = (e.clientY - r.top) / r.height;
        s.classList.add('is-zoom'); lb.classList.add('is-zoomed');
        requestAnimationFrame(function () { s.scrollLeft = fx * s.scrollWidth - r.width / 2; s.scrollTop = fy * s.scrollHeight - r.height / 2; });
      });
      document.addEventListener('keydown', function (e) {
        if (lb.hidden) return;
        if (e.key === 'Escape') close();
        else if (e.key === 'ArrowRight') show(idx() + 1, true);
        else if (e.key === 'ArrowLeft') show(idx() - 1, true);
      });
      window.addEventListener('resize', function () { if (!lb.hidden) show(idx(), false); });
    }
  }
})();

  } catch(e) { console.error(e); }
})();
})();
